/*
 * SPDX-FileCopyrightText: 2023-2025 CERN.
 * SPDX-License-Identifier: MIT
 */

import {
  BasicInformationExtraFields,
  RecommendedInformationExtraFields,
  InstrumentsAccordion,
} from "@js/b3share/deposit/depositOverrides";

export const overriddenComponents = {
  "InvenioAppRdm.Deposit.AccordionFieldBasicInformation.extra": BasicInformationExtraFields,
  "InvenioAppRdm.Deposit.AccordionFieldRecommendedInformation.extra": RecommendedInformationExtraFields,
  "InvenioAppRdm.Deposit.RecommendedInformation.after.container": InstrumentsAccordion,
};
